<template>
  <div class="home" >
    <div
      class=" flex flex-wrap flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex flex-wrap px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">All Learners</div>
        <div class="filter-sort flex flex-wrap items-center">
          <div class="filter flex items-center">
            <i class="text-gray-500 fas fa-filter"></i>
            <span class="font-semibold mr-2 ml-1">Filter By: </span>
            <div class="relative">
              <select
                class="w-32 block appearance-none bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-full leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="grid-state"
              >
                <option>All Learners</option>
                <option>Email</option>
                <option>Phone</option>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="sort ml-12 flex items-center">
            <i class="text-gray-500 fas fa-sort-amount-up"></i>
            <span class="font-semibold mr-3 ml-2">Sort By: </span>
            <div class="relative">
              <select
                class="w-32 block appearance-none bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-full leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="grid-state"
              >
                <option>Name</option>
                <option>Email</option>
                <option>Phone</option>
              </select>
              <div
                class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
              >
                <svg
                  class="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="relative mx-12 border border-gray-300 focus:shadow-md focus:border-none flex-col rounded-full flex mb-6"
      >
        <input
          class="w-full leading-tight h-10 border-none px-4 bg-gray-200 focus:bg-white focus:outline-none rounded-full pl-10"
          v-model="quickSearch"
          placeholder="Search by Name, Email, or Phone number"
          type="text"
        />
        <div
          class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <svg
            class="fill-current pointer-events-none text-gray-600 w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="px-8" >
      <learner-table
        v-if="filteredRecords.length > 0"
        :headers="headers"
        :items="filteredRecords"
        class="mb-4"
      />
      <div class="text-center text-2xl font-semibold text-black" v-else>
        <empty message="No Learner Found" />
      </div>
    </div>
    <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
  <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
    <div>
      <p class="text-sm text-gray-700">
        Showing
        <span class="font-medium">{{currentPage}}</span>
        to
        <span class="font-medium">{{endIndex}}</span>
        of
        <span class="font-medium">{{getTenantLearners.pagination.total}}</span>
        results
      </p>
    </div>
    <div>
        <a  @click="paginateData(currentPage - 1)" class="relative cursor-pointer inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
          <span class="sr-only">Previous</span>
          <!-- Heroicon name: chevron-left -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
    <!-- <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination"  v-for="id in getTenantLearners.pagination.total" :key="id">
        <a  v-if="id <= endIndex && id > startIndex " 
         @click="paginateData(id)" 
        :class="['relative inline-flex  items-center px-4 py-2 border border-gray-300 cursor-pointer  text-sm font-medium text-gray-700 hover:bg-gray-50',id === currentPage ? 'bg-blue-500 ': 'bg-white']">
             {{id }}
        </a>
        </nav> -->

           <span    :class="['relative inline-flex  items-center px-4 py-2 border border-gray-300 cursor-pointer  text-sm font-medium text-gray-700 hover:bg-gray-50',currentPage >= endIndex ? 'bg-blue-500 ': 'bg-white']">
          ...
        </span>


         <!-- <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination"   
         v-for="index in getTenantLearners.pagination.total" :key="index">
        
         <span v-if="index > getTenantLearners.pagination.total - 5"  class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">
          {{index + 1}}
        </span>
        
      </nav> -->
        <a @click="paginateData(currentPage + 1)"  class="relative cursor-pointer inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
          <span class="sr-only">Next</span>
          <!-- Heroicon name: chevron-right -->
          <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
        </a>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { mapActions, mapMutations,mapGetters } from "vuex";
import Empty from "../../../components/general/Empty";

export default {
  name: "user-home",
  data() {
    return {
      learners: [],
      quickSearch: "",
        currentPage:1,
        startIndex:0,
        increment:10,
        endIndex:10,
        showButton:true,
      headers: [
        { key: "name", width: "25%", sortable: true },
        {
          key: "email",
          width: "25%",
          sortable: true,
        },
        {
          key: "gender",
          width: "15%",
          sortable: true,
        },
        {
          key: "phone",
          width: "15%",
          sortable: true,
          defaultSortBy: true,
          defaultOrder: "DESC",
        },
        { type: "actions", key: "Actions", width: "20%" },
      ],
    };
  },
  computed: {
    ...mapGetters(["getTenantLearners"]),
      trackData(){
          return this.learners.length
      },
    filteredRecords() {
      try {
        let data = []
         this.getTenantLearners.data.forEach((user) => {
              let obj = {};
              obj.name = `${user.first_name} ${user.last_name}`;
              obj.email = user.email;
              obj.gender = user.gender;
              obj.id = user.id;
              obj.phone = user.phone_number;
              data.push(obj);
          });
      let users = data.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) > -1
          );
        });
      });

      //console.log(users)

      return users;
      }
      catch(err) {
        let data = []
         this.getTenantLearners.forEach((user) => {
              let obj = {};
              obj.name = `${user.first_name} ${user.last_name}`;
              obj.email = user.email;
              obj.gender = user.gender;
              obj.id = user.id;
              obj.phone = user.phone_number;
              data.push(obj);
          });
      let users = data.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) > -1
          );
        });
      });
      console.log( this.getTenantLearners.pagination)
      // this.getTenantLearners.pagination.current_page = this.currentPage;
      return users;
      }

    },
  },
  components: {
    Empty,
      LmsButton: () => import("@/components/general/button"),
    lbutton: () => import("@/components/general/button"),
    LearnerTable: () => import("@/components/tenant/tables/learners"),
  },
  methods: {
    ...mapActions(["tenantListUsers"]),
    ...mapMutations(["updateLoader"]),

      async paginateData(page){
        if(page > this.endIndex){
          this.startIndex += this.increment
          this.endIndex += this.increment;
        }
        else if(page <= this.startIndex){
          this.startIndex -= this.increment
          this.endIndex -= this.increment;
        }
        try{
           this.updateLoader(true);
          let res = await this.tenantListUsers({
              page: page
          });
          this.updateLoader(false);
          this.currentPage = page
        }
        catch(err){
          this.updateLoader(false);
        }
         

      }
  },
  async created() {
    this.updateLoader(true);
    let res = await this.tenantListUsers();
    // console.log('main tenantListUsers');
    // console.log(this.filteredRecords);
    console.log(this.headers)
    this.updateLoader(false);

  },
};
</script>
